import React from "react";
import ErrorScreen from "../ErrorScreen";
export default function NotFoundPage() {
    return React.createElement(ErrorScreen, { isNotFoundPage: true });
}
//# sourceMappingURL=index.js.map